
export default function componentStyleOverrides(configTheme) {

    const isDarkMode = (configTheme.mode === 'dark');
    const theme = {
        palette: {
            mode: configTheme.mode || 'light',
            primary: configTheme.primary || {},
            background: configTheme.background || {},
            secondary: configTheme.secondary || {}
        }
    }
    return {
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {}
            `,
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    borderRadius: '4px',
                    // RTL-aware icon spacing using logical properties
                    '& .MuiButton-startIcon': {
                        marginInlineEnd: '8px',
                        marginInlineStart: 0
                    },
                    '& .MuiButton-endIcon': {
                        marginInlineStart: '8px',
                        marginInlineEnd: 0
                    }
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: theme.palette?.background?.paper,
                    border: `1px solid ${theme.palette?.divider}`,
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        borderColor: `${theme.palette?.primary?.main}40`,
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                    }
                },
                rounded: {
                    borderRadius: '16px'
                },
                elevation1: {
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                },
                elevation2: {
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.12)',
                },
                elevation3: {
                    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '16px',
                    border: `1px solid ${theme.palette?.divider || 'rgba(0, 0, 0, 0.12)'}`,
                    boxShadow: 'none',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                        borderColor: `${theme.palette?.primary?.main || '#1976d2'}20`,
                    }
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    // padding: '24px 24px 16px 24px',
                    '& .MuiCardHeader-avatar': {
                        marginInlineEnd: '8px',
                        marginInlineStart: 0,
                    }
                },
                title: {
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    lineHeight: 1.4,
                },
                subheader: {
                    fontSize: '0.875rem',
                    marginTop: '4px',
                    opacity: 0.7,
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    // padding: '0 24px',
                    // '&:last-child': {
                    //     paddingBottom: '24px',
                    // }
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    // padding: '16px 24px 24px 24px',
                    // gap: '8px',
                    // '& .MuiButton-root': {
                    //     minHeight: '36px',
                    // }
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    margin: '2px 8px',
                    padding: '12px 16px',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        backgroundColor: `${theme.palette?.primary?.main}08`,
                        // RTL-aware hover transform
                        '[dir="rtl"] &': {
                            transform: 'translateX(-2px)',
                        },
                        '[dir="ltr"] &, &': {
                            transform: 'translateX(2px)',
                        },
                    },
                    '&.Mui-selected': {
                        backgroundColor: `${theme.palette?.primary?.main}12`,
                        color: theme.palette?.primary?.main,
                        borderInlineStart: `3px solid ${theme.palette?.primary?.main}`,
                        '&:hover': {
                            backgroundColor: `${theme.palette?.primary?.main}16`,
                        },
                        '& .MuiListItemIcon-root': {
                            // color: theme.palette?.primary?.main,
                        },
                        '& .MuiListItemText-primary': {
                            fontWeight: 600,
                        }
                    },
                    '&:focus-visible': {
                        outline: `2px solid ${theme.palette?.primary?.main}`,
                        outlineOffset: '2px',
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    // RTL-aware input adornment spacing using logical properties
                    '& .MuiInputAdornment-positionStart': {
                        marginInlineEnd: '8px',
                        marginInlineStart: 0,
                    },
                    '& .MuiInputAdornment-positionEnd': {
                        marginInlineStart: '8px',
                        marginInlineEnd: 0,
                    },
                },
                input: {
                    padding: '16px 14px',
                    color: isDarkMode ? '#ffffff' : theme.palette?.text?.primary,
                    borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)',
                    '&::placeholder': {
                        opacity: isDarkMode ? 0.7 : 0.6
                    },
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '12px 14px',
                        fontSize: '0.8125rem',
                    },
                    // RTL-aware text alignment and padding using logical properties
                    '[dir="rtl"] &': {
                        textAlign: 'right'
                    },
                    '[dir="ltr"] &, &': {
                        textAlign: 'left'
                    },
                },
                notchedOutline: {
                    borderRadius: '8px',
                    borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
                    '& legend': {
                        '[dir="rtl"] &': {
                            textAlign: 'right'
                        },
                        '[dir="ltr"] &, &': {
                            textAlign: 'left'
                        },
                        fontSize: '0.7em',
                    },
                    '&.Mui-focused': {
                        borderColor: isDarkMode ? '#f0f0f0' : theme.palette?.primary?.main,
                    },
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider,
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primary200
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    fontSize: '0.8125rem',
                    fontWeight: 500,
                    height: '32px',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    },
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit',
                        fontSize: '18px',
                        marginInlineStart: '5px',
                        marginInlineEnd: '-6px',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.08)',
                            borderRadius: '50%',
                        }
                    }
                },
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.paper,
                    background: theme.colors?.grey700
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    color: isDarkMode ? '#f0f0f0' : theme.palette?.text?.secondary,
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    // RTL-aware label positioning with proper spacing
                    '[dir="rtl"] &': {
                        transformOrigin: 'top right',
                        right: 20, // Added more margin for RTL
                        left: 'auto'
                    },
                    '[dir="ltr"] &, &': {
                        transformOrigin: 'top left',
                        right: 'auto',
                        left: 14
                    },
                    '&.MuiInputLabel-shrink': {
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        color: isDarkMode ? '#f0f0f0' : theme.palette?.primary?.main,
                        transform: 'translate(0, -4px) scale(0.75)',
                        '[dir="rtl"] &': {
                            transformOrigin: 'top right',
                            right: 20, // Maintain spacing when shrunk
                            left: 'auto'
                        },
                        '[dir="ltr"] &, &': {
                            transformOrigin: 'top left',
                            right: 'auto',
                            left: 14
                        }
                    },
                    '&.Mui-focused': {
                        color: isDarkMode ? '#f0f0f0' : theme.palette?.primary?.main,
                    },
                    '&.Mui-error': {
                        color: theme.palette?.error?.main,
                    }
                },
                outlined: {
                    // RTL positioning for outlined inputs with proper margin
                    '[dir="rtl"] &': {
                        right: 20, // Increased margin for better visual alignment
                        left: 'auto',
                        transformOrigin: 'top right'
                    },
                    '[dir="ltr"] &, &': {
                        right: 'auto',
                        left: 14,
                        transformOrigin: 'top left'
                    },
                    '&.MuiInputLabel-shrink': {
                        transform: 'translate(0px, -4px) scale(0.75)',
                        '[dir="rtl"] &': {
                            transformOrigin: 'top right',
                            right: 20, // Maintain proper spacing when focused/shrunk
                            left: 'auto'
                        },
                        '[dir="ltr"] &, &': {
                            transformOrigin: 'top left',
                            right: 'auto',
                            left: 14
                        }
                    }
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    // RTL-aware form label positioning based on component direction
                    '[dir="rtl"] &': {
                        transformOrigin: 'top right',
                        textAlign: 'right'
                    },
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    marginBottom: '8px',
                    color: theme.palette?.text?.primary,
                    '&.Mui-focused': {
                        color: theme.palette?.primary?.main,
                    },
                    '&.Mui-error': {
                        color: theme.palette?.error?.main,
                    }
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    '& .MuiSwitch-switchBase': {
                        '&.Mui-checked': {
                            '& + .MuiSwitch-track': {
                                backgroundColor: '#4caf50',
                                opacity: 1,
                                border: 0,
                            },
                        }
                    },
                    '&.Mui-focusVisible .MuiSwitch-thumb': {
                        color: '#3a853cff',
                    },
                    // },
                    '& .MuiSwitch-thumb': {
                        boxSizing: 'border-box',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    },
                    '& .MuiSwitch-track': {
                        backgroundColor: '#bdbdbd',
                        opacity: 1,
                        transition: theme.transitions?.create(['background-color'], {
                            duration: 1500,
                        }),
                    },
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    borderRadius: '4px',
                    padding: '8px',
                    '&:hover': {
                        backgroundColor: `${isDarkMode ? '#f0f0f0' : theme.palette?.primary?.main}08`,
                    },
                    '&.Mui-checked': {
                        color: isDarkMode ? '#f0f0f0' : theme.palette?.primary?.main,
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: '1.25rem',
                    }
                }
            }
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    padding: '8px',
                    '&:hover': {
                        backgroundColor: `${theme.palette?.primary?.main || '#1976d2'}08`,
                    },
                    '[dir="ltr"] &, &': {
                        transformOrigin: 'top left',
                        textAlign: 'left'
                    },
                    '&.Mui-checked': {
                        color: theme.palette?.primary?.main || '#1976d2',
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: '1.25rem',
                    }
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    paddingInlineEnd: '48px !important', // Increased padding to prevent overlap with arrow
                    paddingInlineStart: '14px',
                    '&:focus': {
                        backgroundColor: 'transparent',
                    },
                    // Ensure proper text alignment and spacing
                    '[dir="rtl"] &': {
                        paddingInlineEnd: '48px !important',
                        paddingInlineStart: '14px',
                        textAlign: 'right'
                    },
                    '[dir="ltr"] &, &': {
                        paddingInlineEnd: '48px !important',
                        paddingInlineStart: '14px',
                        textAlign: 'left'
                    }
                },
                icon: {
                    transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    pointerEvents: 'none', // Prevent icon from interfering with select
                    // RTL-aware arrow positioning - arrow on right in LTR, left in RTL
                    '[dir="rtl"] &': {
                        right: 'auto',
                        left: '14px',
                    },
                    '[dir="ltr"] &, &': {
                        right: '14px',
                        left: 'auto',
                    }
                },
                iconOpen: {
                    transform: 'rotate(180deg)',
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                    border: `1px solid ${theme.palette?.divider || 'rgba(0, 0, 0, 0.12)'}`,
                    marginTop: '4px',
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    margin: '2px 8px',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        backgroundColor: `${theme.palette?.primary?.main}08`,
                    },
                    '&.Mui-selected': {
                        backgroundColor: `${theme.palette?.primary?.main}12`,
                        '&:hover': {
                            backgroundColor: `${theme.palette?.primary?.main}16`,
                        }
                    }
                }
            }
        }
    };
}
